import type { TFunction } from 'i18next';
import { z } from 'zod';

import { HcpSchema } from '@/core/graphql/generated/validation.zod';

export const NameSectionSchema = (t?: TFunction) => {
	const raw = HcpSchema().pick({
		firstNameCda_V: true,
		lastNameCda_V: true,
		middleNameCda_V: true,
		prefixCda_V: true,
		suffixCda_V: true
	});

	const requiredMsg = t
		? t('This field is required')
		: 'This field is required';

	return z.object({
		// Mandatory fields
		firstNameCda_V: raw.shape.firstNameCda_V
			.pipe(z.string())
			.transform(s => s.replace(/\s+/g, ' ').trim())
			.refine(s => s.length > 0, { message: requiredMsg }),

		lastNameCda_V: raw.shape.lastNameCda_V
			.pipe(z.string())
			.transform(s => s.replace(/\s+/g, ' ').trim())
			.refine(s => s.length > 0, { message: requiredMsg }),

		// Optional fields: keep normalized strings (empty string is allowed)
		middleNameCda_V: raw.shape.middleNameCda_V
			.pipe(z.string())
			.transform(s => s.replace(/\s+/g, ' ').trim()),

		prefixCda_V: raw.shape.prefixCda_V
			.pipe(z.string())
			.transform(s => s.trim()),

		suffixCda_V: raw.shape.suffixCda_V.pipe(z.string()).transform(s => s.trim())
	});
};

export type NameSectionValuesIn = z.input<ReturnType<typeof NameSectionSchema>>;
export type NameSectionValuesOut = z.output<
	ReturnType<typeof NameSectionSchema>
>;
